import React from "react";

import CategorySwiper from "../../home/categories_swiper/CategorySwiper";
import Doctors from "./doctors/Doctors";
import "./ContentSection.css";
import { useDispatch, useSelector } from "react-redux";
import { setDoctorFilter } from "../../../features/doctor/doctorSlice";
const data = [
  {
    id: 1,
    name: "General Healthcare",
    img: "/assets/images/doctor_consultation/img1.png",
    bg: "#ECF9FF",
  },
  {
    id: 2,
    name: "Child & Women Care",
    img: "/assets/images/doctor_consultation/img2.png",
    bg: "#F2EFFF",
  },
  {
    id: 3,
    name: "Heart & Body Specialists",
    img: "/assets/images/doctor_consultation/img3.png",
    bg: "#F5F5F5",
  },
  {
    id: 4,
    name: "Skin & Lifestyle",
    img: "/assets/images/doctor_consultation/img4.png",
    bg: "#ECF1FF",
  },
  {
    id: 5,
    name: "Dental & Eye Care",
    img: "/assets/images/doctor_consultation/img5.png",
    bg: "#DEFFF7",
  },
  {
    id: 6,
    name: "General Healthcare",
    img: "/assets/images/doctor_consultation/img2.png",
    bg: "#FFF2DE",
  },
  {
    id: 7,
    name: "Dental & Eye Care",
    img: "/assets/images/doctor_consultation/img1.png",
    bg: "#F0F5FF",
  },
  {
    id: 7,
    name: "Skin & Lifestyle",
    img: "/assets/images/doctor_consultation/img3.png",
    bg: "#ECF9FF",
  },
];

const catsBreakPoints = {
  320: { slidesPerView: 2.2 },
  575: { slidesPerView: 3 },
  768: { slidesPerView: 4 },
  992: { slidesPerView: 4 },
  1200: { slidesPerView: 5 },
};

export default function ContentSection() {
  const dispatch = useDispatch();

  const category = useSelector((state) => state.master.specializationCategory);

  const filters = useSelector((state) => state.doctor.filters);

  const handleCategoryCardClick = (id) => {
    dispatch(
      setDoctorFilter({
        category_id: Number(filters?.category_id) === Number(id) ? "" : id,
      }),
    );
  };
  return (
    <div className="Content-Section">
      <CategorySwiper
        breakpoints={catsBreakPoints}
        data={category}
        handleCategoryCardClick={handleCategoryCardClick}
        filters={filters}
        show_acitve={true}
      />
      <Doctors />
    </div>
  );
}
